module.exports = __webpack_public_path__ + "img/Winnie@2x.a8ec175e.png";